<template>
  <div class="loginPage">
    <div class="loginColumn">
      <img class="loginLogo" src="@/assets/searchLogo.svg" />
      <img class="loginImage" src="@/assets/loginIcon.png" />
      <img class="loginLogoText" src="@/assets/CourseLnk.png" />
    </div>
    <div class="loginColumn">
      <form @submit.prevent="login" class="loginForm">
        <p class="loginTitle">Set up your account</p>
        <p>redirecting</p>
      </form>
    </div>
    <div class="bottomNav">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <router-link
        class="landingButton"
        :to="{
          name: 'Landingpage',
        }"
        >About</router-link
      >
      <router-link
        class="landingButton"
        :to="{ name: 'Terms' }"
        target="_blank"
      >
        Terms and Conditions
      </router-link>
      <router-link
        class="landingButton"
        :to="{ name: 'Privacy' }"
        target="_blank"
      >
        Privacy Policy
      </router-link>
      <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
        Join the team
      </router-link>
    </div>
    <div class="bottomNavSmall">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{
            name: 'Landingpage',
          }"
          >About</router-link
        >
        <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
          Join the team
        </router-link>
      </div>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{ name: 'Terms' }"
          target="_blank"
        >
          Terms and Conditions
        </router-link>
        <router-link
          class="landingButton"
          :to="{ name: 'Privacy' }"
          target="_blank"
        >
          Privacy Policy
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
//import firebase from "@/firebase";
import firebase from "@/firebase";

export default {
  mounted() {
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        const urlParams = new URLSearchParams(window.location.search);
        var mode = urlParams.get("mode");
        var actionCode = urlParams.get("oobCode");
        var continueUrl = urlParams.get("continueUrl");
        var lang = urlParams.get("lang") || "en";
        // Ge,t the action to complete.

        // (Optional) Get the continue URL from the query parameter if available.
        // (Optional) Get the language code if available.
        // Configure the Firebase SDK.
        // This is the minimum configuration required for the API to be used.
        var auth = firebase.auth();
        // Handle the user management action.
        switch (mode) {
          case "resetPassword":
            // Display reset password handler and UI.
            this.handleResetPassword(auth, actionCode, continueUrl, lang);
            break;
          case "recoverEmail":
            // Display email recovery handler and UI.
            this.handleRecoverEmail(auth, actionCode, lang);
            break;
          case "verifyEmail":
            // Display email verification handler and UI.
            this.handleVerifyEmail(auth, actionCode, continueUrl, lang);
            break;
          default:
          // Error: invalid mode.
        }
      },
      false
    );
  },

  methods: {
    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },
    backToLogin() {
      this.$router.push({ name: "Login" });
    },

    handleVerifyEmail(auth, actionCode, continueUrl, lang) {
      // Localize the UI to the selected language as determined by the lang
      // parameter.
      // Try to apply the email verification code.
      console.log(lang, continueUrl);

      auth
        .applyActionCode(actionCode)
        .then((resp) => {
          console.log(resp, "resp");
          if (this.iOS()) {
            window.location.replace(
              "https://courselnk.page.link/emailVerified"
            );
          } else {
            this.$router.push({ name: "SetUp" });
          }
          // Email address has been verified.
          // TODO: Display a confirmation message to the user.
          // You could also provide the user with a link back to the app.
          // TODO: If a continue URL is available, display a button which on
          // click redirects the user back to the app via continueUrl with
          // additional state determined from that URL's parameters.
        })
        .catch((error) => {
          console.log(error);

          // Code is invalid or expired. Ask the user to verify their email address
          // again.
        });
    },

    handleResetPassword(auth, actionCode, url, lang) {
      // Localize the UI to the selected language as determined by the lang
      // parameter.
      console.log(url, lang);
      this.$store.commit("setPassword/setActionCode", actionCode);
      this.$router.push({ name: "SetPassword" });

      // Verify the password reset code is valid.
    },

    handleRecoverEmail(auth, actionCode, lang) {
      console.log(lang);
      // Localize the UI to the selected language as determined by the lang
      // parameter.
      var restoredEmail = null;
      // Confirm the action code is valid.

      auth
        .checkActionCode(actionCode)
        .then((info) => {
          // Get the restored email address.
          restoredEmail = info["data"]["email"];

          // Revert to the old email.
          return auth.applyActionCode(actionCode);
        })
        .then(() => {
          // Account email reverted to restoredEmail

          // TODO: Display a confirmation message to the user.

          // You might also want to give the user the option to reset their password
          // in case the account was compromised:
          auth
            .sendPasswordResetEmail(restoredEmail)
            .then(() => {
              // Password reset confirmation sent. Ask user to check their email.
            })
            .catch((error) => {
              // Error encountered while sending password reset code.
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);

          // Invalid code.
        });
    },
  },
};
</script>

<style scoped src="@/styles/components/auth/Login.css"></style>
